<template>
  <panel :title="$tc('tournament.change_history')" :max-height="500" collapsable>
    <el-table :data="data" style="width: 100%">
      <el-table-column :label="$tc('general.change')">
        <template slot-scope="scope">
          <b>{{ scope.row.user ? scope.row.user.name : $t('general.deleted_user') }}</b>
          {{ $t('changes.' + scope.row.type) }}
          <b>{{ getItemName(scope.row) }}</b>
        </template>
      </el-table-column>
      <el-table-column :label="$tc('general.date')" width="200px" align="right">
        <template slot-scope="scope">
          {{ scope.row.createdAt | date('DD.MM.YYYY HH:mm') }}
        </template>
      </el-table-column>
    </el-table>
  </panel>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    getItemName (row) {
      const item = row.item
      if (!item || !item.member) return ''
      return `${item.member.firstName || ''} ${item.member.lastName || ''}`.trim()
    }
  }
}
</script>
